import { inputAddressHouseSize, inputHeightAddress } from '~src/branding';
import { Icon } from '~src/components/Icon';
import { useDisplayContext } from '~src/context/DisplayContext';

import { FormElementWrapperNorlys } from '../FormElementWrapper';
import { AddressInput as AddressInputCommon, AddressInputProps } from './common';
import { AddressInputWrapper } from './style';

export const AddressInput = ({ size = 'middle', style, ...rest }: AddressInputProps) => {
  const houseSize = inputAddressHouseSize(size);
  const height = inputHeightAddress(size);

  const { isMobile } = useDisplayContext();

  return (
    <AddressInputWrapper {...{ size, style }}>
      <AddressInputCommon {...rest} />
      <Icon.House
        width={houseSize}
        height={houseSize}
        {...{
          style: {
            position: 'absolute',
            top: '50%',
            transform: 'translate(0, -50%)',
            left: `calc((${height} - ${houseSize})/${isMobile ? 1 : 2})`,
          },
        }}
      />
    </AddressInputWrapper>
  );
};

export const AddressInputNorlys = ({ size = 'middle', style, ...rest }: AddressInputProps) => (
  <FormElementWrapperNorlys {...{ size, style, label: 'Indtast adresse' }}>
    <AddressInputCommon {...rest} />
  </FormElementWrapperNorlys>
);
